export const BASE_URL = `${process.env.REACT_APP_BASE_URL}/patient`;
export const PUBLIC_TOKEN = process.env.REACT_APP_PUBLIC_TOKEN;
